import React from 'react';
import { Base, Typography } from 'lib/cortiUI';
export const SettingsSection = ({ title, children }) => (React.createElement(Base, { display: "grid", gap: 6 },
    title && (React.createElement(Typography, { variant: "h4", color: "default", mb: 7 }, title)),
    children));
